import { useMemo } from 'react'
import InsightViewOption, { InsightViewOptionStrings } from 'enums/InsightViewOption'
import {
  generateBrandsInsightStrategy,
  generateEmojiInsightStrategy,
  generateHashtagsInsightStrategy,
  generatePeopleInsightStrategy,
  generateProductNameInsightStrategy,
  generateSentimentInsightStrategy,
  generateTermsInsightStrategy,
  generateThingsInsightStrategy
} from 'utils/insightModal/strategy/searchFilterComposing'

const useSearchFilterComposingStrategy = (viewOption: InsightViewOptionStrings) => {
  const searchFilterComposingStrategy = useMemo(() => {
    switch (viewOption) {
      case InsightViewOption.BRANDS:
        return generateBrandsInsightStrategy()

      case InsightViewOption.EMOJIS_GROUP:
      case InsightViewOption.EMOJIS_EMOTION:
      case InsightViewOption.EMOJIS_EMOJI:
        return generateEmojiInsightStrategy()

      case InsightViewOption.HASHTAGS:
        return generateHashtagsInsightStrategy()

      case InsightViewOption.PEOPLE:
        return generatePeopleInsightStrategy()

      case InsightViewOption.PRODUCT_NAME:
        return generateProductNameInsightStrategy()

      case InsightViewOption.TERMS:
        return generateTermsInsightStrategy()

      case InsightViewOption.THINGS:
        return generateThingsInsightStrategy()

      case InsightViewOption.ATTRIBUTES:
      case InsightViewOption.BEHAVIORS:
      case InsightViewOption.EMOTIONS:
        return generateSentimentInsightStrategy()

      default:
        throw new Error(`Unsupported view option: ${viewOption}`)
    }
  }, [viewOption])
  return searchFilterComposingStrategy
}

export default useSearchFilterComposingStrategy
